import React from 'react';
import PropTypes from 'prop-types';
import { BLOCKS, MARKS } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';

const Bold = ({ children }) => <span className="bold">{children}</span>;
Bold.propTypes = {
  children: PropTypes.node.isRequired,
};

const Text = ({ children }) => <p className="align-justify">{children}</p>;
Text.propTypes = {
  children: PropTypes.node.isRequired,
};

const options = {
  renderMark: {
    [MARKS.BOLD]: (text) => <Bold>{text}</Bold>,
  },
  renderNode: {
    [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
    renderText: (text) => text.replace('\n', '<br/>'),
  },
};

const parser = (document) => {
  return documentToReactComponents(document, options);
};

export default parser;
